/* import __COLOCATED_TEMPLATE__ from './class-groups.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class ClassGroupsComponent extends Component 
{
	@service store;
	
	@tracked isAddingNew = false;
	
	@tracked newClassGroupName = "";
	@tracked newClassGroupFormat = "";
	
	@action
	async saveNew(browserEvent)
	{
		browserEvent.preventDefault();
		
		const newClassGroup = this.store.createRecord('class-group',
		{
			name: this.newClassGroupName,
			format: this.newClassGroupFormat,
			EventId: this.args.event,
		});
		try
		{
			await newClassGroup.save();
		}
		catch (error)
		{
			alert(error);
			return;
		}
		
		await this.store.findRecord('classGroup',newClassGroup.id);
		
		this.newClassGroupName = "";
		this.newClassGroupFormat = "";
		this.isAddingNew = false;
	};
	
	@action
	cancelNew()
	{
		this.newClassGroupName = "";
		this.newClassGroupFormat = "";
		this.isAddingNew = false;
	};
	
	@action
	async courseSelectionChanged(classGroup,browserEvent)
	{		
		var course = browserEvent.target.value;
		
		const existingCourseId = classGroup.CourseId.content;
		
		if(course == '-')
		{
			classGroup.CourseId = null;
		}
		else
		{
			let foundCourse = this.store.peekRecord('course', course);
			classGroup.CourseId = foundCourse;
		}
		
		try
		{
			await classGroup.save();
		}
		catch(error)
		{
			alert(error);
			classGroup.CourseId = existingCourseId;
		}
	};
	
	@action
	async classGroupStatusChanged(classGroup,browserEvent)
	{		
		let status = browserEvent.target.value;
		
		classGroup.status = status;
		
		try
		{
			await classGroup.save();
		}
		catch(error)
		{
			alert(error);
			classGroup.rollbackAttributes();
		}
	};
	
	@action
	async deleteClassGroup(classGroup)
	{
		const classes = await classGroup.get('classes')

		if(classes.length > 0)
		{
			alert("Class Group has classes assigned. Can not be deleted!");
			return;
		}

		try
		{
			classGroup.deleteRecord();
			classGroup.save();
		}
		catch(error)
		{
			alert(error);
			classGroup.rollbackAttributes();
		}
	};
}